export default (num, min, max) => num <= min ? min : num >= max ? max : num; // eslint-disable-line
